/**
 * IM 事件类型常量
 * 定义所有 IM 相关的事件类型，包括连接状态事件和消息事件
 */

/**
 * IM 连接状态事件类型
 * 用于 IMManager 与 IM Store 之间的连接状态通信
 */
export const IM_EVENT_TYPE = {
  // 连接状态事件
  CONNECTED: 'im:connected',
  DISCONNECTED: 'im:disconnected',
  KICK_OUT: 'im:kickOut',
  AUTH_FAILED: 'im:authFailed',
  ERROR: 'im:error',
  REFRESH_TOKEN: 'im:refreshToken', // Token 刷新事件
}
